import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LIGHT_PATHS = ["/distribution"];

export const Nav = ({ lang, setLang, onConsult, labels, ctaLabel }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const onLight = LIGHT_PATHS.includes(location.pathname);

  const goSection = (id) => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className={`nav ${onLight ? "nav-on-light" : ""}`} data-testid="site-navigation">
      <button className="wordmark" onClick={() => goSection("top")} data-testid="brand-home-button"><Logo variant={onLight ? "dark" : "light"} /></button>
      <div className={`nav-links ${menuOpen ? "open" : ""}`} data-testid="navigation-links">
        {labels.map((item, i) => (
          <button key={item} onClick={() => goSection(["approach", "services", "estates", "about"][i])} data-testid={`nav-link-${i}`}>{item}</button>
        ))}
        <button className="nav-cta" onClick={onConsult} data-testid="nav-consultation-button">{ctaLabel} <ArrowUpRight size={15} /></button>
      </div>
      <div className="nav-tools">
        <div className="lang-switch" data-testid="language-switcher">
          <button className={lang === "en" ? "active" : ""} onClick={() => setLang("en")} data-testid="language-english-button">EN</button><span>/</span>
          <button className={lang === "id" ? "active" : ""} onClick={() => setLang("id")} data-testid="language-indonesian-button">ID</button>
        </div>
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-button">{menuOpen ? <X /> : <Menu />}</button>
      </div>
    </nav>
  );
};
